import * as React from "react";
const SvgSimulation20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 9a7 7 0 1 1 14 0A7 7 0 0 1 2 9Zm7-9a9 9 0 1 0 0 18A9 9 0 0 0 9 0Zm5.244 9L6.3 4.234v9.532L14.244 9Zm-3.888 0L8.3 10.234V7.766L10.356 9Z",
      clipRule: "evenodd"
    })
  );
export default SvgSimulation20Px;
